import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';

import { Link, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import moment from 'moment';
import { getSelectedTranslation, getTranslation } from '../../core/utils/helpers';
import Main from '../../components/layout/Main';
import './noticeboardDetail.scss';

const NoticeboardDetail = () => {

    const { noticeId } = useParams();
    const noticeboard = useSelector(state => state.noticeboard);
    const language = useSelector(state => state.language);
    const [notice, setNotice] = useState(null);

    useEffect(() => {
        // First check if we have a selected noticeboard
        if (noticeboard?.selectedNoticeboard && noticeboard.selectedNoticeboard.id === parseInt(noticeId, 10)) {
            setNotice(noticeboard.selectedNoticeboard);
        } else if (noticeboard?.noticeboardData?.length > 0 && noticeId) {
            const foundNotice = noticeboard.noticeboardData.find(
                item => item.id === parseInt(noticeId, 10),
            );
            setNotice(foundNotice);
        }
    }, [noticeboard?.noticeboardData, noticeboard?.selectedNoticeboard, noticeId]);

    const getNoticeImage = (item, translation) => (
        item?.image_url || item?.image || translation?.image_url || translation?.image || null
    );

    const sanitizeHtml = (html) => {
        if (!html) return '';
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'span', 'div'],
            ALLOWED_ATTR: ['href', 'target', 'style', 'class'],
        });
    };

    const handleOpenLink = (url) => {
        window.open(url, '_blank');
    };

    const returnLinkLabel = (link_label) => {
        if (link_label === null || link_label === undefined) {
            return getTranslation(language, 'link_label_text', 'Link');
        }
        return link_label;
    };

    const renderNoticeDetail = () => {
        if (!notice) {
            return (
                <div className="c-not-found">
                    {getTranslation(language, 'notice_not_found', 'Notice not found')}
                </div>
            );
        }

        const horoscopeTranslation = getSelectedTranslation(notice.translations, language?.selectedLanguage?.id);
        const noticeImage = getNoticeImage(notice, horoscopeTranslation);

        return (
            <div className="c-notice-detail-box">
                {noticeImage && (
                    <div className="c-notice-image">
                        <img src={noticeImage} alt={horoscopeTranslation?.title || 'Notice'} />
                    </div>
                )}
                <div className="c-notice-title">
                    {horoscopeTranslation?.title}
                </div>
                <div className="c-notice-date">
                    {moment(notice?.created_at).format('DD/MM/YYYY')}
                </div>
                <div
                    className="c-notice-description"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: sanitizeHtml(horoscopeTranslation?.description) }} />
                {horoscopeTranslation?.link && (
                    <div
                        onClick={() => handleOpenLink(horoscopeTranslation?.link)}
                        className="c-notice-link">
                        {returnLinkLabel(horoscopeTranslation?.link_label)}
                    </div>
                )}
            </div>
        );
    };

    return (
        <Main
            title={<div>Noticeboard - Prakash Astrologer</div>}
            headerTitle={(
                <div>
                    <img style={{ height: 70, width: 70 }}
                        src="https://prakashastrologer-19e87.kxcdn.com/wp-content/uploads/2020/05/PrakashAstrologerLogo.svg"
                        alt="logo" />
                </div>
            )}
            backLink={(
                <Link to="/noticeboard" className="backlink" />
            )}
            menuWidth={350}
            menuPlacement="right"
            floatingHeader
            displayRightMenu={false}
            showFooter={false}>
            <div className="noticeboard-detail-page">
                <div className="noticeboard-detail-heading">
                    <h2 className="c-page-heading">
                        {getTranslation(language, 'noticeboard', 'Noticeboard')}
                    </h2>
                </div>
                {noticeboard?.isFetching
                    ? (
                        <div className="loaderSpacer">
                            <Spin size="large" />
                        </div>
                    )
                    : renderNoticeDetail()}
            </div>
        </Main>
    );
};

export default NoticeboardDetail;
